<template>
  <CContainer fluid>
    <div class="metro-menu">
      <div 
        class="tile tile-1 small">
        <i class="bi bi-shop"></i>
        <span>Sucursales</span>
      </div>
      <div 
        class="tile tile-2 small bg-s3turquoise">
        <i class="bi bi-person-vcard"></i>
        <span>Empleados</span>
      </div>
      <div 
        class="tile tile-3 small">
        <i class="bi bi-graph-up-arrow"></i>
        <span>Resoluciones DIAN</span>
      </div>
      <!-- <div 
        class="tile small bg-s3orange"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/seguimientos` })">
        <i class="bi bi-chat-square-text"></i>
        <span>Seguimientos</span>
      </div> -->
      <!-- <div 
        class="tile small bg-s3lime"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/calendarioactividades` })">
        <i class="bi bi-calendar3"></i>
        <span>Calendario Actividades</span>
      </div> -->
      <div 
        class="tile small bg-s3rose"
        @click="$router.push({ path: `/${rootPath}/coming-soon` })">
        <i class="bi bi-award"></i>
        <span>Notificaciones</span>
      </div>
    </div>
  </CContainer>
</template>

<style scoped>
  @import "/assets/css/metro-menu.css";
</style>

<script>
  export default {
    name: "CompanyMenu",
    components: {

    },
    data() {
      return {
        rootPath: "",
      }
    },
    methods: {

    },
    mounted() {
      // initializeIcons();

      this.rootPath = this.$router.currentRoute.fullPath.split("/")[1];

      console.log(this.rootPath);
    },
    beforeDestroy() {

    }
  }
</script>
